import { ReconciliationItem, ReconciliationQuery } from '../Model/reconciliationXModel'
import { cashReconciliationBXService } from './cashReconciliationBXService'
import { formatReportDate } from '../Utils/stationOperations'

export const reconciliationBXService = {
  list: async (
    query: ReconciliationQuery,
  ): Promise<{ data: ReconciliationItem[]; total: number }> => {
    const response = await cashReconciliationBXService.listReconciliation(query)
    return {
      data: (response.data.data ?? []).map((row) => ({
        id: `${row.reportResourceId}:${row.product}`,
        reportId: row.reportResourceId,
        station: row.stationName || row.stationId,
        product: row.product,
        reportDate: formatReportDate(row.reportDate),
        pumpSales: row.pumpSalesLitres,
        tankMovement: row.tankSalesLitres,
        variance: row.gainLitres,
        status:
          row.gainLitres === null
            ? 'Not available'
            : row.gainLitres > 0
              ? 'Excess'
              : row.gainLitres < 0
                ? 'Deficit'
                : 'Balanced',
      })),
      total: response.data.meta?.total ?? response.data.data?.length ?? 0,
    }
  },
}
